export default __webpack_public_path__ + "static/media/IMG-20250105-WA0002.2a5e91c9.jpg";